// HMAC-SHA256 signing of offline queue items, so the server can detect tampering.
// The canonical message and hex output MUST match the backend (DeviceSigningService):
//   message = `${deviceId}\n${localId}\n${payloadJson}`  → HMAC-SHA256(secret) → lowercase hex
// Pure (WebCrypto only) so it's unit-testable with node --test.

const fromB64 = (s) => Uint8Array.from(atob(s), (c) => c.charCodeAt(0));
const toHex = (bytes) => Array.from(bytes).map((b) => b.toString(16).padStart(2, '0')).join('');

export function canonical(deviceId, localId, payloadJson) {
  return `${deviceId}\n${localId}\n${payloadJson}`;
}

/** Returns the lowercase-hex HMAC, or '' if there's no signing secret (device not provisioned). */
export async function signItem(secretB64, deviceId, localId, payloadJson) {
  if (!secretB64) return '';
  const key = await crypto.subtle.importKey(
    'raw', fromB64(secretB64), { name: 'HMAC', hash: 'SHA-256' }, false, ['sign']);
  const sig = await crypto.subtle.sign(
    'HMAC', key, new TextEncoder().encode(canonical(deviceId, localId, payloadJson)));
  return toHex(new Uint8Array(sig));
}
